<mat-card appearance="outlined" class="card-container">
    <div class="d-flex flex-wrap flex-column">
        <div class="d-flex flex-row align-items-end mt-3">
            <div class="item-key detail-label table-cell-label">Screening Result</div>
            <div class="table-cell-value">
                <div class="item-status text-center" [style.backgroundColor]="getVerificationResultColor(guestVerificationInfo.verificationResultCode)">
                    {{ guestVerificationInfo.verificationResultCode?.text?.toLowerCase() }}
                </div>
            </div>
        </div>
        <div class="d-flex mt-3">
            <span class="item-value">Last Updated&nbsp;</span>
            <span class="item-value">{{ dateFormat(guestDetails.reservation_guest_details[0].last_update, userContextProvider.region, true) }} UTC</span>
        </div>
        <div 
            class="d-flex align-items-center download-insurance-pdf mt-3"
            (click)="onGuestVerificationPdfDownloadClick()"
        >
            <mat-icon class="download-insurance-pdf-icon">publish</mat-icon>
            Download Guest Screening PDF
        </div>

        <div class="table-container mt-3 mb-2" *ngIf="shouldDisplayScreeningResultColumns()">
            <div class="table-row header">
                <div class="table-cell table-cell-label"> Screening Summary </div>
                <div class="table-cell"> Screening Details </div>
                @if (shouldDisplayNotesColumn) {
                    <div class="table-cell"> Notes </div>
                }
            </div>
            <div class="table-row" *ngFor="let checkType of checksToDisplay">
                <div class="table-cell table-cell-label">
                    {{ getCheckLabel(checkType) }}
                </div>
                <div class="table-cell table-cell-label item-status text-center" [style.backgroundColor]="getVerificationResultColor(getResultCode(checkType))">
                    {{ getResultText(checkType) }}
                </div>
                @if (shouldDisplayNotesColumn) {
                    <div class="table-cell">
                        {{ getNote(checkType) }}
                    </div>
                }
            </div>
        </div>
        <ng-container *ngIf="guestVerificationInfo?.guestPortalCompleted">
            <div class="d-flex align-items-center mt-3" *ngIf="guestVerificationInfo?.riskColor">
                <span class="detail-label me-3">Overall Risk</span>
                <div class="item-status overall-risk-badge" [style.backgroundColor]="guestVerificationInfo.riskColor">
                    {{ getRiskLabel(guestVerificationInfo.riskColor!) }}
                </div>
            </div>
            <div class="mt-3" *ngIf="guestVerificationInfo.topRisks?.length">
                <div class="d-flex align-items-center collapsible-header" (click)="topRisksExpanded = !topRisksExpanded">
                    <span class="item-key detail-label fw-bold">Top Concerns</span>
                    <mat-icon>{{ topRisksExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                </div>
                <ul class="mt-1" *ngIf="topRisksExpanded">
                    <li *ngFor="let risk of guestVerificationInfo.topRisks">{{ risk }}</li>
                </ul>
            </div>
            <div class="mt-3" *ngIf="guestVerificationInfo.topRecommendations?.length">
                <div class="d-flex align-items-center collapsible-header" (click)="topRecommendationsExpanded = !topRecommendationsExpanded">
                    <span class="item-key detail-label fw-bold">Recommendations</span>
                    <mat-icon>{{ topRecommendationsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                </div>
                <ul class="mt-1" *ngIf="topRecommendationsExpanded">
                    <li *ngFor="let rec of guestVerificationInfo.topRecommendations">{{ rec }}</li>
                </ul>
            </div>
        </ng-container>
        <div class="row my-4">
            <button mat-raised-button class="action-button w-fit me-2" (click)="onQuestionClick()" style="margin-right:8px;">
                <mat-icon>search</mat-icon>
                I have a question
            </button>
            <button *ngIf="shouldDisplayDeclineButton()" mat-raised-button class="action-button w-fit me-2" (click)="onDeclineClick()" style="margin-right:8px;">
                <mat-icon>delete</mat-icon>
                Help me decline this Guest
            </button>
            <button mat-raised-button class="warn-button w-fit" (click)="onReverifyGuestClick()" style="margin-right:8px;">
                <mat-icon>redo</mat-icon>
                Reverify Guest
            </button>
            <button *ngIf="guestVerificationInfo.verificationResultCode?.text?.toLowerCase() != 'not available'" mat-raised-button class="action-button w-fit" (click)="onUpdateGuestVerificationResultsClick()">
                <mat-icon>sync</mat-icon>
                Update Guest Verification Results
            </button>
        </div>
    </div>
</mat-card>